import { dateTimeFormatter, euroFormatter } from "../../../global";
import React, { useEffect, useState } from "react";
import InfoList from "../../../components/InfoList";
import InfoListItem from "../../../components/InfoListItem";
import { Button, Dropdown, Modal, Spinner } from "react-bootstrap";
import axios from "../../../config/axios";
import OnlineReservationDeclineDialog from "./OnlineReservationDeclineDialog";
import { useTranslation } from "react-i18next";
import { showValidationErrorToast } from "../../../components/Toasts";

const OnlineReservationDetailsDialog = ({
  reservationBookingId,
  handleClose,
  handleSubmit,
}) => {
  const [showDeclineDialog, setShowDeclineDialog] = useState(false);
  const { t } = useTranslation("dashboard");

  const [onlineReservation, setOnlineReservation] = useState(null);

  useEffect(() => {
    axios
      .get(`api/v1/online_reservations/${reservationBookingId}.json`)
      .then(function (response) {
        setOnlineReservation(response.data);
      });
  }, []);

  async function handleAccept() {
    try {
      await axios.post(
        `/api/v1/stays/${onlineReservation.stay_id}/accept_reservation.json`,
      );
      handleSubmit();
    } catch (error) {
      showValidationErrorToast(error);
    }
  }

  return (
    <>
      <Modal onHide={handleClose} show={!showDeclineDialog}>
        <Modal.Header closeButton>
          <Modal.Title>Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {onlineReservation ? (
            <InfoList>
              <InfoListItem name={"ID"} value={onlineReservation.id} />
              <InfoListItem
                name={"Status"}
                value={onlineReservation.formatted_status}
              />
              {onlineReservation.reservation_code && (
                <InfoListItem
                  name={t("online_reservation_details.reservation_code")}
                  value={t(onlineReservation.reservation_code)}
                />
              )}
              <InfoListItem
                name={"Stellplatz"}
                value={onlineReservation?.parking_slot?.name}
              />
              <InfoListItem
                name={"Anreise"}
                value={dateTimeFormatter(onlineReservation.from)}
              />
              <InfoListItem
                name={"Abreise"}
                value={dateTimeFormatter(onlineReservation.to)}
              />
              <InfoListItem
                name={"Anzahl Gäste (14+ Jahre)"}
                value={onlineReservation.amount_guests}
              />
              <InfoListItem
                name={"Anzahl Gäste (<14 Jahre)"}
                value={onlineReservation.reservation_child_ages.length}
              />
              <InfoListItem
                name={"Anzahl Hunde"}
                value={onlineReservation.amount_dogs}
              />
              <InfoListItem
                name={"Gesamtpreis"}
                value={euroFormatter(onlineReservation.price)}
              />
              <hr />
              <InfoListItem
                name={"Kontaktperson"}
                value={onlineReservation.contact_person}
              />
              <InfoListItem
                name={"E-Mail"}
                value={onlineReservation.contact_email}
              />
              <InfoListItem
                name={"Telefonnummer"}
                value={onlineReservation.contact_phone}
              />
            </InfoList>
          ) : (
            <div className={"d-flex justify-content-center"}>
              <Spinner
                className={"text-center"}
                animation="border"
                variant="primary"
              />
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          {[
            "reservation_requested",
            "reservation_accepted",
            "reservation_declined",
          ].includes(onlineReservation?.state) && (
            <Dropdown>
              <Dropdown.Toggle id="dropdown-basic">
                Status ändern
              </Dropdown.Toggle>

              <Dropdown.Menu>
                {["reservation_requested", "reservation_declined"].includes(
                  onlineReservation.state,
                ) && (
                  <Dropdown.Item onClick={handleAccept}>Annehmen</Dropdown.Item>
                )}
                {["reservation_requested", "reservation_accepted"].includes(
                  onlineReservation.state,
                ) && (
                  <Dropdown.Item onClick={() => setShowDeclineDialog(true)}>
                    Stornieren
                  </Dropdown.Item>
                )}
              </Dropdown.Menu>
            </Dropdown>
          )}
        </Modal.Footer>
      </Modal>
      {showDeclineDialog && (
        <OnlineReservationDeclineDialog
          stayId={onlineReservation.stay_id}
          handleSubmit={handleSubmit}
          handleClose={() => {
            setShowDeclineDialog(false);
          }}
        />
      )}
    </>
  );
};

export default OnlineReservationDetailsDialog;
